import React from "react";
import { Redirect } from "react-router-dom";
// import { isLogin } from "src/app-redux/auth/authSlice";
// import { useAppSelector } from "src/app-redux/hooks";
import { userAttribs } from "src/common/utils/userAttribs4mLocalStorage";

interface Props {
  children: React.ReactNode;
  redirectPath: string;
  path: string;
}

export function RouteGuard(props: Props) {
  console.log("RouteGuard on path: ", props.path);
  // const log = useAppSelector(isLogin);

  return userAttribs() ? <>{props.children}</> : <Redirect to={{ pathname: props.redirectPath }} />;
}
